import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {data: {}},
    table: createTableState(),
    filterData: undefined
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};
        if (page) {
            if (page.current) params.page = page.current;
            if (page.pageSize) params.page_limit = page.pageSize;
        }
        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_subscription'], {params})

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    async show({commit}, {id}) {
        commit('setLoading', true)
        commit('updateSaveData', {})

        const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_subscription'] + '/' + id);

        if (res.data?.status) {
            commit('updateSaveData', res.data.data)
        } else {
            this._vm.$message.error(res.data?.message)
        }

        commit('setLoading', false)
    },

    async add({commit}, {formData}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.post(this._vm.endpoints['ecommerce_subscription'], formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async update({commit}, {id, formData}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(this._vm.endpoints['ecommerce_subscription'] + '/' + id, formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async delete({commit}, {id}) {
        let successDeleted = [];
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successDeleted;
        }

        for (let i = 0; i < id.length; i++) {
            try {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['ecommerce_subscription'] + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            } catch (error) {
                this._vm.onResponseFailure(error.response.data);
            }
        }

        return successDeleted;
    },

    async activate({commit}, {id}) {
        try {
            const res = await this._vm.axios.patch(this._vm.endpoints['ecommerce_subscription_activate'], {}, {
                urlVars: {id}
            });
            return res.data;
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    async cancel({commit}, {id}) {
        try {
            const res = await this._vm.axios.patch(this._vm.endpoints['ecommerce_subscription_cancel'], {}, {
                urlVars: {id}
            });
            return res.data;
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    async suspend({commit}, {id}) {
        try {
            const res = await this._vm.axios.patch(this._vm.endpoints['ecommerce_subscription_suspend'], {}, {
                urlVars: {id}
            });
            return res.data;
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    async resume({commit}, {id}) {
        try {
            const res = await this._vm.axios.patch(this._vm.endpoints['ecommerce_subscription_resume'], {}, {
                urlVars: {id}
            });
            return res.data;
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    async extend({commit}, {id, days}) {
        try {
            const res = await this._vm.axios.patch(this._vm.endpoints['ecommerce_subscription_extend'], {days}, {
                urlVars: {id}
            });
            return res.data;
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
